import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage, FormattedNumber, FormattedHTMLMessage } from 'react-intl';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import { ga } from 'helpers/multitrack';
import currencyCodeToSymbol from 'constants/currency-code-to-symbol'; // We should eventually refactor currencyCodeToSymbol out of the code

var renderPrice = function renderPrice(number, currency) {
  return React.createElement("div", {
    className: "text--bold pricing-compare__number"
  }, React.createElement("span", {
    className: "pricing-compare__symbol"
  }, currencyCodeToSymbol(currency)), React.createElement("span", null, React.createElement(FormattedNumber, {
    value: number,
    maximumFractionDigits: number % 1 === 0 ? 0 : 1
  })));
};

export var ComparePricingUnwrapped =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ComparePricingUnwrapped, _PureComponent);

  function ComparePricingUnwrapped() {
    _classCallCheck(this, ComparePricingUnwrapped);

    return _possibleConstructorReturn(this, _getPrototypeOf(ComparePricingUnwrapped).apply(this, arguments));
  }

  _createClass(ComparePricingUnwrapped, [{
    key: "onDwell",
    value: function onDwell() {
      ga('Compare Pricing Module', 'Viewed compare pricing module', null, 0, {
        nonInteraction: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theirPrice = _this$props.theirPrice,
          currency = _this$props.currency,
          ourPrice = _this$props.ourPrice,
          backgroundColor = _this$props.backgroundColor;
      return React.createElement("div", {
        className: "bg--".concat(backgroundColor || 'white')
      }, React.createElement("div", {
        className: "pricing-compare"
      }, React.createElement("h2", {
        className: "mv+"
      }, React.createElement(FormattedMessage, {
        id: "pricing-compare.title",
        defaultMessage: "Compare our prices"
      })), React.createElement("p", {
        className: "pricing-compare__subtitle mv"
      }, React.createElement(FormattedMessage, {
        id: "pricing-compare.subtitle",
        defaultMessage: "ClassPass membership is the most affordable way to try studio fitness, and the easiest way to sample multiple studios."
      })), React.createElement("div", {
        className: "grid mt mb md-ph++"
      }, React.createElement("div", {
        className: "grid__item 1/2 pricing-compare__price"
      }, React.createElement("div", null, React.createElement("h1", null, renderPrice(theirPrice || 32, currency || 'USD')), React.createElement("p", {
        className: "text--bold text--lg mv-"
      }, React.createElement(FormattedMessage, {
        id: "pricing-compare.fitness-studio",
        defaultMessage: "Fitness studio"
      })), React.createElement("p", {
        className: "color-text-light"
      }, React.createElement(FormattedHTMLMessage, {
        id: "pricing-compare.fitness-studio-subtext",
        defaultMessage: "Average cost of class<br>through a single studio"
      })))), React.createElement("div", {
        className: "grid__item 1/2 pricing-compare__price"
      }, React.createElement("h1", null, renderPrice(ourPrice || 13.5, currency || 'USD')), React.createElement("p", {
        className: "text--bold text--lg mv-"
      }, React.createElement(FormattedMessage, {
        id: "pricing-compare.classpass",
        defaultMessage: "ClassPass"
      })), React.createElement("p", {
        className: "color-text-light"
      }, React.createElement(FormattedHTMLMessage, {
        id: "pricing-compare.classpass-subtext",
        defaultMessage: "Price per class on a<br>10 class monthly membership"
      }))))));
    }
  }]);

  return ComparePricingUnwrapped;
}(PureComponent);
ComparePricingUnwrapped.propTypes = {
  theirPrice: PropTypes.number,
  ourPrice: PropTypes.number,
  currency: PropTypes.string,
  backgroundColor: PropTypes.oneOf(['white', 'light'])
};
export var ComparePricing = trackDwell(ComparePricingUnwrapped);